/* eslint-disable max-lines */
/* eslint-disable vars-on-top */
/* eslint-disable max-statements*/
/* eslint-disable complexity*/
/* eslint-disable max-len */
/* eslint-disable no-ternary */
ACC.productDetail = {
  initPageEvents: function() {
    $('.productImageGallery .jcarousel-skin').jcarousel({
      vertical: true
    });

    $(document).on('click', '#imageLink, .productImageZoomLink', function(event) {
      event.preventDefault();

      $.colorbox({
        href: $(this).attr('href'),
        height: 555,
        onComplete: function() {
          ACC.common.refreshScreenReaderBuffer();

          $('#colorbox .productImageGallery .jcarousel-skin').jcarousel({
            vertical: true
          });
        },
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    });

    $('.productImageGallery img').click(function() {
      $('.productImagePrimary img').attr('src', $(this).attr('data-primaryimagesrc'));
      $('#zoomLink, #imageLink').attr('href', $('#zoomLink').attr('data-href') + '?galleryPosition=' + $(this).attr('data-galleryposition'));
      $('.productImageGallery .thumb').removeClass('active');
      $(this).parent('.thumb').addClass('active');
    });

    $(document).on('click', '#colorbox .productImageGallery img', function() {
      $('#colorbox  .productImagePrimary img').attr('src', $(this).attr('data-zoomurl'));
      $('#colorbox .productImageGallery .thumb').removeClass('active');
      $(this).parent('.thumb').addClass('active');
    });

    $('body').on('keyup', 'input[name=qtyInput]', function(event) {
      var $input = $(event.target);
      var value = $input.val();
      var $qtyCss = 'input[name=qty]';

      while ($input.parent()[0] !== document) {
        $input = $input.parent();

        if ($input.find(function(item) {
          return $qtyCss(item);
        }).length > 0) {
          $input.find(function(item) {
            return $qtyCss(item);
          }).val(value);

          return;
        }
      }
    });

    $('#Size').change(function() {
      var url = '';
      var selectedIndex = 0;

      $('#Size option:selected').each(function() {
        url = $(this).attr('value');
        selectedIndex = $(this).attr('index');
      });

      if (selectedIndex !== 0) {
      /* eslint-disable xss/no-location-href-assign*/
        window.location.href = url;
      }
    });

    $('#variant').change(function() {
      var url = '';
      var selectedIndex = 0;

      $('#variant option:selected').each(function() {
        url = $(this).attr('value');
        selectedIndex = $(this).attr('index');
      });

      if (selectedIndex !== 0) {
        window.location.href = url;
      }
    });

    $('.selectPriority').change(function() {
      var url = '';
      var selectedIndex = 0;

      url = $(this).attr('value');
      selectedIndex = $(this).attr('index');

      if (selectedIndex !== 0) {
        window.location.href = url;
        /* eslint-enable xss/no-location-href-assign*/
      }
    });
  }
};

$(document).ready(function() {
  var prodcode = $('#ph-prod-code').val(),
      prodctv = $('#ph-prod-ctv').val();

  /* eslint-disable no-undef*/
  /* eslint-disable no-with */
  with (ACC.productDetail) {
    initPageEvents();
    /* eslint-enable no-with */
    /* eslint-enable no-undef */
  }

  if ($('#product-detail-content-top').length > 0) {
    if ($('#ph-prod-ctv').length > 0) {
      ACC.googleanalytics.gaProductdetailpage(prodctv);
    } else {
      ACC.googleanalytics.gaProductdetailpage(prodcode);
    }
  }
});

$('.ph-notify-sec').click(function() {
  var imgUrl = $('#ph-pdp-primeImage').attr('src');

  $.colorbox({
    width: '390px',
    maxWidth: '90%',
    height: 'auto',
    /* eslint-disable xss/no-mixed-html */
    html: $('.ph-notifypop').html(),
    /* eslint-enable xss/no-mixed-html */
    overlayClose: true
  });

  if ($('#ph-pdp-primeImage').length > 0) {
    $('#cboxLoadedContent #ph-pdpImgPOP').attr('src', imgUrl);
  }

  $.colorbox.resize();
  $('.ph-notifypopContent .ph-regforminput').trigger('keyup');
});

$(document).on('click', '.ph-notifyPDP', function() {
  var prodcode = $('.ph-pdpcode').val(),
      email = $('.ph-pdpemail').val(),
      qtyVal = $('#cboxLoadedContent .ph-notifyquantity').attr('id', 'ph-PdpQty-' + prodcode).val();

  $.ajax({
    url: ACC.config.encodedContextPath + '/asyncproduct/backInStockNotifyRequest',
    type: 'POST',
    datatype: 'json',
    data: {
      product12Nc: prodcode,
      email: email,
      quantityRequested: qtyVal
    },
    success: function() {
      $.colorbox({
        width: '400px',
        maxWidth: '90%',
        height: 'auto',
        /* eslint-disable xss/no-mixed-html */
        html: $('.ph-notifyconfirmpop').html(),
        /* eslint-enable xss/no-mixed-html */
        overlayClose: true
      });
    }
  });
});


$(document).on('keyup', '.ph-notifypopContent .ph-pdpemailinput', function() {
  var emailValue = $(this).val(),
      notifybutton = '.ph-pdpnotifybut',
      disablebutton = 'disable-button',
      signError = 'signup__error',
      formFieldErr = 'field_error ph-form_field_error',
      emailEmptyVal = 'email__emptyvalue',
      redAlertMg = 'redalert-msg',
      notifyemailElement = '.ph-notifypopContent .ph-inputData';

  $('.ph-pdpemail').val(emailValue);

  if (ACC.contactpagebuttons.email(emailValue)) {
    $(notifyemailElement).find('.ph-' + signError).addClass('form_' + formFieldErr);
    $(notifyemailElement).find('.ph-' + emailEmptyVal).text($(notifyemailElement).attr('data-emptyContent')).addClass('ph-' + redAlertMg);
    $(notifybutton).addClass('ph-' + disablebutton);
  } else {
    $(notifyemailElement).find('.ph-' + signError).removeClass('form_' + formFieldErr);
    $(notifyemailElement).find('.ph-' + emailEmptyVal).text('').removeClass('ph-' + redAlertMg);
    $(notifybutton).removeClass('ph-' + disablebutton);
  }
});

ACC.productDetailsPage = {
  atpDataFromApi: '',
  loadPriceConditioncheckforpdp: function(resultList, indx) {
    var product = resultList[indx],
        prodPriceList = resultList[indx].priceList,
        discVal = resultList[indx].discountPromotion,
        promotiontoggleenable = $('.ph-promotiontoggleenable').val(),
        pdpmainproductcode = '.ph-pdpmainproduct-',
        pricesText = '',
        addStrikeClass = '',
        ribbonText = $(pdpmainproductcode + product.code).find('.ph-discount-ribbon__text').html(),
        maxQtyEnabled = $('#maxQuantityToggle').val(),
        freeMarketingProductVal = $(pdpmainproductcode + product.code).find('.ph-freeMarketingProductCls').val(),
        freePriceText = $('.ph-freePriceText').val();

    for (var priceIndx = 0; priceIndx < prodPriceList.length; priceIndx = priceIndx + 1) {
      var rowPrice = prodPriceList[priceIndx];

      addStrikeClass = '';

      /* eslint-disable xss/no-mixed-html */
      if (rowPrice.priceType === 'FROM' && promotiontoggleenable === 'true') {
        addStrikeClass = 'ph-pdpstrikeprice-value';

        var $discRibbon = $(pdpmainproductcode + product.code).find('.ph-discount-ribbon__text');

        $discRibbon.html(ribbonText.replace('{0}', discVal));
        $(pdpmainproductcode + product.code).find('.ph-discount-ribbon').removeClass('hidden');
        pricesText = pricesText + ('<span class="ph-product-card__previous-price ' + addStrikeClass + '">' + rowPrice.formattedValue + '</span>');
      } else if (rowPrice.priceType === 'BUY' && rowPrice.pricingConditionCode !== 'YLRR' && rowPrice.value !== 0.0) {
        $(pdpmainproductcode + product.code).find('.ph-discount-ribbon').addClass('hidden');
        pricesText = pricesText + ('<span class="ph-pdpprice-value ' + addStrikeClass + '">' + rowPrice.formattedValue + '</span>');
      } else if (freeMarketingProductVal === 'true' && rowPrice.pricingConditionCode === 'PNTP' && rowPrice.value === 0.0) {
        $(pdpmainproductcode + product.code).find('.ph-discount-ribbon').addClass('hidden');
        pricesText = pricesText + ('<span class="ph-pdpprice-value ' + addStrikeClass + '">' + freePriceText + '</span>');
      }

      if (rowPrice.iconType === 'red') {
        $(pdpmainproductcode + product.code).find('.ph-promotionicon__red').removeClass('ph-d-none');
        $(pdpmainproductcode + product.code).find('.ph-promotionenddate').html(rowPrice.promotionEndDate);
      } else if (rowPrice.iconType === 'blue') {
        $(pdpmainproductcode + product.code).find('.ph-promotionicon__blue').removeClass('ph-d-none');
        $(pdpmainproductcode + product.code).find('.ph-pricedate').html(rowPrice.promotionEndDate);
      }

      if (rowPrice.pricingConditionCode === 'YLRR' && rowPrice.formattedValue !== null) {
        $(pdpmainproductcode + product.code).find('.ph-rrpvalue-pdp').html(rowPrice.formattedValue);
      } else if (rowPrice.pricingConditionCode === 'YLRR' && rowPrice.formattedValue === null) {
        $(pdpmainproductcode + product.code).find('.ph-rrpvalue-pdp').addClass('hidden');
      }
      /* eslint-enable xss/no-mixed-html */
    }

    $(pdpmainproductcode + product.code).find('.ph-prices-section').html(pricesText);

    if ($.trim($('.ph-prices-section').text()).length > 0 && (maxQtyEnabled === 'true' && $('.ph-product-count:visible').length > 0)) {
      $('.add_to_cart_form').show();
    } else if ($.trim($('.ph-prices-section').text()).length > 0 && maxQtyEnabled === 'false') {
      $('.add_to_cart_form').show();
    }
  },
  getAtpData: function(prodCodes, successCallback, failureCallback) {
    if (prodCodes) {
      $.ajax({
        url: ACC.config.encodedContextPath + '/asyncproduct/getatpdata',
        type: 'POST',
        datatype: 'json',
        data: {
          code: prodCodes.toString()
        },
        success: function(data) {
          successCallback(data);
        },
        error: function(error) {
          if (failureCallback) {
            failureCallback(error);
          }
        }
      });
    }
  },
  checkAllMaxQtyConditions: function(ele) {
    var productQty = parseInt($(ele).val(), 10),
        nobackorderprod = $('#ph-nobackorderprod').val(),
        maxQtyEnabled = $('#maxQuantityToggle').val() === 'true',
        /* Commenting to refer to different element
        maxQty = parseInt($('#ph-item_maxQuantity_value').text(), 10), */

        maxQty = parseInt($('.ph-annual-max-qunaity-value').val(), 10),
        lowStockQuantity = parseInt($('.phi-trafficLight-Container .ph-availCount:visible').text(), 10),
        pdpaddtocartbtnDot = 'ph-pdp_addtocart_button',
        /* Commenting as not used
        productmaxstockqty = parseInt($('#ph-productmaxstockqty').val(), 10),
        */
        totalOrdered = parseInt($('#ph-item_orderedQuantity_value').text(), 10),
        freeMarktingProduct = $('.ph-is-free-marketing-product').val() === 'true',
        freeMarktingMaxQty = parseInt($('.ph-free-marketing-max-qunaity-value').val(), 10),
        maxQtyText = '',
        prodAtpData = ACC.productDetailsPage.atpDataFromApi,
        dchainProdToggle = $('.ph-dchain-product-toggle').val(),
        dChainValue = prodAtpData.dchainValue,
        dChainFirstEntry = ACC.common.getDChainFirstEntry(prodAtpData),
        // eslint-disable-next-line no-negated-condition
        dChainFirstEntryDate = dChainFirstEntry !== null ? Object.keys(dChainFirstEntry)[0] : '',
        // eslint-disable-next-line  compat/compat, no-negated-condition
        dChainFirstEntryQty = dChainFirstEntry !== null ? Object.values(dChainFirstEntry)[0] : '';

    maxQty = isNaN(maxQty) ? -1 : maxQty;
    lowStockQuantity = isNaN(lowStockQuantity) ? -1 : lowStockQuantity;
    totalOrdered = isNaN(totalOrdered) ? -1 : totalOrdered;
    freeMarktingMaxQty = isNaN(freeMarktingMaxQty) ? -1 : freeMarktingMaxQty;

    var maxQtyReqParams = {
      nobackorderprod: nobackorderprod,
      maxQtyEnabled: maxQtyEnabled,
      enteredQty: productQty,
      lowStockQty: prodAtpData.atpData.lowStockQty,
      maxQty: maxQty,
      totalOrdered: totalOrdered,
      isFreeMarketingProduct: freeMarktingProduct,
      freeMarketingMaxQty: freeMarktingMaxQty,
      dChainProductToggle: dchainProdToggle,
      dChainProductValue: dChainValue,
      dChainProductFirstEntryDate: dChainFirstEntryDate,
      dChainProductFirstEntryQty: dChainFirstEntryQty
    };

    maxQtyText = ACC.common.checkAllMaxQtyValidation(maxQtyReqParams);


    $('.ph-productMaxQty_popupMsgError').addClass('hidden');
    $('.ph-prodMaxStockQuantity').addClass('hidden');
    $('.ph-productFreeMarketingMaxQty_popupMsg').addClass('hidden');
    $('.ph-productDChainMaxQty_popupMsg').addClass('hidden');
    $('.ph-pdp-cartbtn-wrapper').find('.' + pdpaddtocartbtnDot).removeAttr('disabled').removeClass('ph-outofstockdisablebtn');

    // C maxQtyText = ACC.common.getLowestMaxQtyValue(nobackorderprod === 'true', maxQtyEnabled, productQty, lowStockQuantity, maxQty, totalOrdered, freeMarktingProduct, freeMarktingMaxQty);

    if (maxQtyText === 'lowStock') {
      $('.ph-prodMaxStockQuantity').removeClass('hidden').find('.ph-backordermaxcountdec').text($('.ph-prodMaxStockQuantity').find('.ph-backordermaxcountdec').text().replace('0', lowStockQuantity));
      $('.ph-pdp-cartbtn-wrapper').find('.ph-pdp_addtocart_button').addClass('ph-outofstockdisablebtn');
    } else if (maxQtyText === 'maxQty') {
      $('.ph-productMaxQty_popupMsgError').removeClass('hidden');
      $('.ph-pdp-cartbtn-wrapper').find('.ph-pdp_addtocart_button').addClass('ph-outofstockdisablebtn');
      $('.ph-productMaxQty_popupMsgError').html($('.ph-productMaxQty_popupMsgError').html().replace('{0}', maxQty - totalOrdered));
    } else if (maxQtyText === 'freeMarketingMaxQty') {
      $('.ph-productFreeMarketingMaxQty_popupMsg').removeClass('hidden').find('.ph-free-max-qty-value').text(freeMarktingMaxQty);
      $('.ph-pdp-cartbtn-wrapper').find('.ph-pdp_addtocart_button').addClass('ph-outofstockdisablebtn');
    } else if (maxQtyText === 'dChain50' || maxQtyText === 'dChain30') {
      $('.ph-productDChainMaxQty_popupMsg').removeClass('hidden').find('.ph-dchain-max-qty-value').text(dChainFirstEntryQty);
      $('.ph-pdp-cartbtn-wrapper').find('.ph-pdp_addtocart_button').addClass('ph-outofstockdisablebtn');
    }
  }
};

$(document).ready(function() {
  var emailValue = $('.ph-pdpemailinput').val(),
      notifybutton = '.ph-pdpnotifybut',
      disablebutton = 'disable-button',
      notifyemailElement = '.ph-notifypopContent .ph-inputData',
      phaseintitle = '',
      phaseouttitle = '',
      maxWidthtitle = '',
      stockalgnin = 0,
      stockalgnout = 0,
      maxWidth = 0,
      signError = 'signup__error',
      formFieldErr = 'field_error ph-form_field_error',
      emailEmptyVal = 'email__emptyvalue',
      redAlertMg = 'redalert-msg';

  if (ACC.contactpagebuttons.email(emailValue)) {
    $(notifyemailElement).find('.ph-' + signError).addClass('form_' + formFieldErr);
    $(notifyemailElement).find('.ph-' + emailEmptyVal).text($(notifyemailElement).attr('data-emptyContent')).addClass('ph-' + redAlertMg);
  } else {
    $(notifyemailElement).find('.ph-' + signError).removeClass('form_' + formFieldErr);
    $(notifyemailElement).find('.ph-' + emailEmptyVal).text('').removeClass('ph-' + redAlertMg);
    $(notifybutton).removeClass('ph-' + disablebutton);
  }

  if ($('.ph-phase-inout-section').length > 0) {
    phaseintitle = $('.ph-phaseintitle').width();
    phaseouttitle = $('.ph-phaseouttitle').width();
    maxWidthtitle = Math.max(phaseintitle, phaseouttitle) + 5;

    $('.ph-phaseinouttitle').css('width', maxWidthtitle + 'px');
    stockalgnin = $('#ph-stockalgnin').width();
    stockalgnout = $('#ph-stockalgnout').width();
    maxWidth = Math.max(stockalgnin, stockalgnout) + 8;
    $('.ph-stockiconalgn').css('width', maxWidth + 'px');
  }


  if ($('.page-productDetails').length > 0) {
    var trafficlightContainer = '.phi-trafficLight-Container',
        prodCodes = $('#ph-prod-code').val(),
        pdpAddcartBtn = 'pdp_addtocart_button',
        nobackorderprod = $('#ph-nobackorderprod').val(),
        backInStockNotify = $('#ph-notifyflag').val(),
        maxQtyEnabled = $('#maxQuantityToggle').val(),
        isPricingCallEnabled = $('.ph-enablepricingcall').length > 0,
        isAtpAvailable = $('.ph-atp-enabled').length > 0,
        isFreeMarketingProd = $('.ph-is-free-marketing-product').val(),
        dChainFlagForEvent = false;

    if (isAtpAvailable === false || isPricingCallEnabled === false) {
      $('.add_to_cart_form').show();
    }

    if (isAtpAvailable === true) {
      ACC.productDetailsPage.getAtpData(prodCodes, function(atpresult) {
        if (atpresult) {
          var $backordcountdec = $('.ph-productQtytool').find('.ph-backordermaxcountdec'),
              existingtext = '',
              dChainProductToggle = $('.ph-dchain-product-toggle').val(),
              dChainProductValue = atpresult.dchainValue,
              dChainProdValidFrom = atpresult.validFrom,
              dChainFirstEntry = ACC.common.getDChainFirstEntry(atpresult),
              // eslint-disable-next-line no-negated-condition
              dChainFirstEntryDate = dChainFirstEntry !== null ? Object.keys(dChainFirstEntry)[0] : '',
              // eslint-disable-next-line no-negated-condition, compat/compat
              dChainFirstEntryQty = dChainFirstEntry !== null ? parseInt(Object.values(dChainFirstEntry)[0], 0) : '';

          ACC.productDetailsPage.atpDataFromApi = atpresult;

          $('#ph-productmaxstockqty').val(atpresult.atpData.maxStockQty);

          if (atpresult.atpData.availabilityCode === 'red') {
            $(trafficlightContainer).find('.ph-avail-red').removeClass('hidden');

            if (nobackorderprod === 'true') {
              $('.ph-pdp_addtocart_button').addClass('ph-outofstockdisablebtn');
            }
          }

          if (atpresult.atpData.availabilityCode === 'green') {
            $(trafficlightContainer).find('.ph-avail-green').removeClass('hidden');
            existingtext = $backordcountdec.text();
            $backordcountdec.text(existingtext.replace('{0}', atpresult.atpData.maxStockQty));
          }

          if (atpresult.atpData.availabilityCode === 'orange') {
            $(trafficlightContainer).find('.ph-availCount').html(atpresult.atpData.lowStockQty);
            $(trafficlightContainer).find('.ph-avail-orange').removeClass('hidden');
            existingtext = $backordcountdec.text();
            $backordcountdec.text(existingtext.replace('{0}', atpresult.atpData.maxStockQty));
          }

          if (dChainProductToggle === 'true' && dChainProductValue !== '' && dChainProductValue !== null) {
            if (dChainProductValue === '30') {
              if ((nobackorderprod === 'false' &&
                ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate)) ||
                ((nobackorderprod === 'true') &&
                (atpresult.atpData.availabilityCode === 'green' || atpresult.atpData.availabilityCode === 'orange') &&
                ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))
              ) {
                $('.ph-pdp_addtocart_button').removeClass('ph-outofstockdisablebtn');
              } else if ((nobackorderprod === 'true' && atpresult.atpData.availabilityCode === 'red') ||
                !(ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))
              ) {
                $('.ph-pdp_addtocart_button').addClass('ph-outofstockdisablebtn');

                // Hiding Deal Ribbon when product is dchain conditions are met
                $('.ph-available-deals-container').addClass('ph-d-none');

                // eslint-disable-next-line max-depth
                if ((atpresult.atpData.availabilityCode === 'green' || atpresult.atpData.availabilityCode === 'orange') &&
                  !ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate)) {
                  $(trafficlightContainer).find('> span').addClass('hidden');

                  // eslint-disable-next-line max-depth
                  if (atpresult.atpData.availabilityCode === 'green') {
                    $(trafficlightContainer).find('.ph-avail-30-future-instock').removeClass('hidden');
                  } else if (atpresult.atpData.availabilityCode === 'orange') {
                    $(trafficlightContainer).find('.ph-avail-30-future-lowstock').removeClass('hidden');
                  }
                }

                dChainFlagForEvent = true;
              }
            } else if (dChainProductValue === '50') {
              if ((atpresult.atpData.availabilityCode === 'red') || (!ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate) && (dChainFirstEntryQty === '' || dChainFirstEntryQty <= 0))) {
                $('.ph-pdp_addtocart_button').addClass('ph-outofstockdisablebtn');
                $(trafficlightContainer).find('> span').addClass('hidden');
                $(trafficlightContainer).find('.ph-avail-50-nostock').removeClass('hidden');
                dChainFlagForEvent = true;

                // Hiding Deal Ribbon when product is dchain conditions are met
                $('.ph-available-deals-container').addClass('ph-d-none');
              }
            }
          }

          if (!((atpresult.atpData.availabilityCode === 'red' && nobackorderprod === 'true') || dChainFlagForEvent)) {
            $('.ph-pdpquantity').keyup(function() {
              ACC.productDetailsPage.checkAllMaxQtyConditions($(this));
            });
          }
        }

        if ($('.ph-avail-red').is(':visible') && nobackorderprod === 'true' && backInStockNotify === 'true') {
          $('.ph-' + pdpAddcartBtn).addClass('ph-d-none');
          $('.ph-pdpnotifypop').removeClass('hidden');
          $('.ph-pdpquantity').addClass('hidden');
          $('.ph-pdp_qtyminus').addClass('hidden');
          $('.ph-pdp_qtyplus').addClass('hidden');
        }

        if (($('.ph-avail-red:visible').length > 0 || $('.ph-avail-green:visible').length > 0 || $('.ph-avail-orange:visible').length > 0) && (maxQtyEnabled === 'true' && $('.ph-product-count:visible').length > 0)) {
          $('.add_to_cart_form').show();
        } else if (($('.ph-avail-red:visible').length > 0 || $('.ph-avail-green:visible').length > 0 || $('.ph-avail-orange:visible').length > 0) && maxQtyEnabled === 'false') {
          $('.add_to_cart_form').show();
        }
      });
    }

    if (isPricingCallEnabled === true) {
      ACC.decisionPageInfiniteLoader.getPriceData(prodCodes, function(resultList) {
        if (Array.isArray(resultList) && resultList.length > 0) {
          for (var indx = 0; indx < resultList.length; indx = indx + 1) {
            ACC.productDetailsPage.loadPriceConditioncheckforpdp(resultList, indx);
          }
        }
      });
    }

    if (maxQtyEnabled === 'true' || isFreeMarketingProd === 'true') {
      $.ajax({
        url: ACC.config.encodedContextPath + '/asyncproduct/getmaxquantity',
        type: 'POST',
        datatype: 'json',
        data: {
          codes: $('#ph-productCode').val()
        },
        success: function(result) {
          var resultProd = result.productMaxQtyDatas[0],
              maxQty = resultProd.maxQtyToOrder,
              freeMarketingMaxQty = resultProd.maxMarketingMatQtyToOrder,
              isFreeMarketingProduct = resultProd.isFreeMarketingMaterial,
              lowestMaxQty = maxQty,
              maxQtyEnabledAndDataAvail = maxQtyEnabled === 'true' && maxQty > 0,
              freeMarktingProdAndDataAvail = isFreeMarketingProduct && freeMarketingMaxQty > 0;

          if ((freeMarktingProdAndDataAvail && maxQtyEnabledAndDataAvail && freeMarketingMaxQty < maxQty) || !maxQtyEnabledAndDataAvail) {
            lowestMaxQty = freeMarketingMaxQty;
          }

          if (maxQtyEnabledAndDataAvail || freeMarktingProdAndDataAvail) {
            if (Array.isArray(result.productMaxQtyDatas) && result.productMaxQtyDatas.length > 0) {
              $('#ph-item_maxQuantity_value').html(lowestMaxQty);
              $('#ph-item_orderedQuantity_value').html(resultProd.totalOrdered === -1 ? 0 : resultProd.totalOrdered);
              $('.ph-free-marketing-max-qunaity-value').val(resultProd.maxMarketingMatQtyToOrder);
              $('.ph-annual-max-qunaity-value').val(maxQty);

              $('.ph-product-count').removeClass('hidden');

              if (resultProd.showError === true || resultProd.maxQtyToOrder === 0) {
                $('.ph-pdp-cartbtn-wrapper').on('mouseenter', function() {
                  $('.ph-productAnnualMaxMsg').removeClass('hidden');
                });
                $('.ph-pdp-cartbtn-wrapper').on('mouseleave', function() {
                  $('.ph-productAnnualMaxMsg').addClass('hidden');
                });
                $('.ph-pdp-cartbtn-wrapper').find('.ph-pdp_addtocart_button').addClass('ph-outofstockdisablebtn');
              }
            }
          }
        }
      });
    }
  }
});
/* eslint-enable no-ternary */
/* eslint-enable max-len */
/* eslint-enable max-lines */
/* eslint-enable vars-on-top */
/* eslint-enable max-statements*/
/* eslint-enable complexity*/
